import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=2aa6d9f7&scoped=true&"
import script from "./language-switcher.vue?vue&type=script&lang=ts&"
export * from "./language-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./language-switcher.vue?vue&type=style&index=0&id=2aa6d9f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6d9f7",
  null
  
)

export default component.exports